import React from 'react';

import { makeClassNames, IClassNames } from '../../utils/styles';
import './badge-new-posts.scss';
import t from '../../labels/labelling-utils';
import IconRefresh from '../icons/icon-refresh';

export interface IBadgeNewPostsProps {
  count: number;
  isShown?: boolean;
  href?: string;
  intcmp?: string;
  onClick?: () => void;
}

const classNames = (): IClassNames =>
  makeClassNames({
    BadgeNewPosts: 'badge-new-posts',
    BadgeNewPostsIcon: 'badge-new-posts__icon',
    BadgeNewPostsText: 'badge-new-posts__text',
    IsVisible: 'is-visible',
  });

const BadgeNewPosts: React.FC<IBadgeNewPostsProps> = ({ count, href, isShown, onClick }) => {
  const cn = classNames();
  const newPostsText = `${count} ${
    count === 1 ? t('badge.new.posts.text.singular') : t('badge.new.posts.text.plural')
  }`;

  return (
    <a className={`${cn.BadgeNewPosts} ${isShown ? cn.IsVisible : ''}`} href={href} onClick={onClick}>
      <span className={cn.BadgeNewPostsIcon}>
        <IconRefresh />
      </span>
      <span className={cn.BadgeNewPostsText}>{newPostsText}</span>
    </a>
  );
};

export default BadgeNewPosts;
